import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Address from '@afosto/app-components-react/Address';
import SkeletonBody from '@afosto/components-react/SkeletonBody';
import getFullName from '@afosto/utils/getFullName';
import { addresses as addressesApi } from '@afosto/contacts/api/Addresses';

const AddressFormatter = ({ addressId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [address, setAddress] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchAddress = async id => {
      setIsLoading(true);

      try {
        const response = await addressesApi.viewAddress(id);
        const { data = null } = response;

        if (isMounted) {
          setAddress(data);
        }
      } catch (err) {
        if (isMounted) {
          setAddress(null);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    if (addressId) {
      fetchAddress(addressId);
    }

    return () => {
      isMounted = false;
    };
  }, [addressId]);

  if (isLoading) {
    return <SkeletonBody lines={1} />;
  }

  if (!address) {
    return '-';
  }

  return (
    <Address
      company={address.organisation}
      fullName={getFullName(address)}
      addressLine1={address.address_line_1}
      addressLine2={address.address_line_2}
      postalCode={address.postal_code}
      city={address.locality}
      country={address.country_code}
      administrativeArea={address.administrative_area}
    />
  );
};

AddressFormatter.propTypes = {
  addressId: PropTypes.string,
};

AddressFormatter.defaultProps = {
  addressId: undefined,
};

export default AddressFormatter;
